// extracted by mini-css-extract-plugin
module.exports = {"item":"kn","dark":"ko","light":"kp","toggle":"kq"};